import { render, staticRenderFns } from "./product_bee.vue?vue&type=template&id=546ebdd6&scoped=true"
import script from "./product_bee.vue?vue&type=script&lang=js"
export * from "./product_bee.vue?vue&type=script&lang=js"
import style0 from "./product_bee.vue?vue&type=style&index=0&id=546ebdd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546ebdd6",
  null
  
)

export default component.exports